import groq from 'groq'

import { mediaAsset } from '../../../projections/mediaAsset'

export const team = groq`
  _type,
  upperTitle,
  title,
  description,

  members[]{
    ...,
    photo[0]{...${mediaAsset()}}
  },

`
